class BotroueTheme {
  constructor() {
    document.documentElement.classList.remove('no-js');
    this.bindTabs();
    this.bindQuantity();
    this.bindHeader();
    this.bindThemeEditor();
  }

  activateTab(button) {
    const tabs = button.closest('[data-tabs]');
    if (!tabs) return;

    const buttons = [...tabs.querySelectorAll('[data-tab-button]')];
    const panels = [...tabs.querySelectorAll('[data-tab-panel]')];
    const id = button.dataset.tabButton;

    buttons.forEach((item) => {
      const active = item === button;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-selected', active ? 'true' : 'false');
      item.tabIndex = active ? 0 : -1;
    });

    panels.forEach((panel) => {
      panel.hidden = panel.dataset.tabPanel !== id;
    });
  }

  bindTabs() {
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-tab-button]');
      if (!button) return;
      this.activateTab(button);
    });

    document.addEventListener('keydown', (event) => {
      const current = event.target.closest('[data-tab-button]');
      if (!current || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

      const tabs = current.closest('[data-tabs]');
      const buttons = [...tabs.querySelectorAll('[data-tab-button]')];
      if (!buttons.length) return;

      event.preventDefault();
      const index = buttons.indexOf(current);
      let nextIndex = index;
      if (event.key === 'ArrowRight') nextIndex = (index + 1) % buttons.length;
      if (event.key === 'ArrowLeft') nextIndex = (index - 1 + buttons.length) % buttons.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = buttons.length - 1;

      buttons[nextIndex].focus();
      this.activateTab(buttons[nextIndex]);
    });
  }

  bindQuantity() {
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-quantity-button]');
      if (!button) return;
      const wrapper = button.closest('[data-quantity]');
      const input = wrapper?.querySelector('input[type="number"]');
      if (!input) return;
      const step = Number(input.step || 1);
      const min = Number(input.min || 1);
      const next = button.dataset.quantityButton === 'plus' ? Number(input.value) + step : Number(input.value) - step;
      input.value = Math.max(min, next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  bindHeader() {
    const update = () => {
      document.querySelectorAll('[data-site-header]').forEach((header) => {
        header.classList.toggle('is-scrolled', window.scrollY > 20);
      });
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  bindThemeEditor() {
    document.addEventListener('shopify:block:select', (event) => {
      const block = event.target.closest('[data-tabs]')?.querySelector(`[data-tab-button="${event.detail.blockId}"]`);
      if (block) this.activateTab(block);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => new BotroueTheme());
